import { render } from "./IntroCard.vue?vue&type=template&id=519b0bef&bindings={\"title\":\"props\",\"text\":\"props\",\"imageURL\":\"props\",\"textHTML\":\"data\"}"
import script from "./IntroCard.vue?vue&type=script&lang=js"
export * from "./IntroCard.vue?vue&type=script&lang=js"

import "./IntroCard.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script